var map = {
	"./CR.icon.svg": "LmKN",
	"./apps.icon.svg": "AQWK",
	"./arrow.icon.svg": "Wp4G",
	"./bargraph.icon.svg": "4eOw",
	"./book.icon.svg": "gE6L",
	"./building.icon.svg": "PVGL",
	"./calendar.icon.svg": "UeWC",
	"./cart.icon.svg": "Zcfz",
	"./chain.icon.svg": "lW2K",
	"./circle-tick.icon.svg": "5ybu",
	"./clipboard.icon.svg": "9iuE",
	"./clock.icon.svg": "CFo+",
	"./close.icon.svg": "UuQD",
	"./cloud-up.icon.svg": "qg2a",
	"./cog.icon.svg": "6syw",
	"./contestdream.cellphone.icon.svg": "80N/",
	"./contestdream.cursor.icon.svg": "8B6J",
	"./contestdream.facebook.icon.svg": "ZStU",
	"./contestdream.finaldrawssolo.icon.svg": "HKFJ",
	"./contestdream.graphic.icon.svg": "3UWC",
	"./contestdream.instantdraws.icon.svg": "0CjD",
	"./contestdream.jury.icon.svg": "oega",
	"./contestdream.logo.icon.svg": "4xDN",
	"./contestdream.music.icon.svg": "xovh",
	"./contestdream.novel.icon.svg": "rgeV",
	"./contestdream.paint.icon.svg": "wXU+",
	"./contestdream.photo.icon.svg": "zcq2",
	"./contestdream.poem.icon.svg": "7IIL",
	"./contestdream.qr.icon.svg": "1Z/E",
	"./contestdream.question.icon.svg": "3AW/",
	"./contestdream.smile.icon.svg": "TkPh",
	"./contestdream.t.icon.svg": "0Qhn",
	"./contestdream.text.icon.svg": "Nwyg",
	"./contestdream.tick.icon.svg": "xRyM",
	"./contestdream.twitter.icon.svg": "flok",
	"./contestdream.video.icon.svg": "RbQk",
	"./dashboard.icon.svg": "2rj0",
	"./development.icon.svg": "/xCq",
	"./document.icon.svg": "RMKM",
	"./dollar.icon.svg": "ExBe",
	"./email.icon.svg": "0Vyd",
	"./emitter.icon.svg": "waPM",
	"./facebook.icon.svg": "mks6",
	"./feelgrid.humidity.icon.svg": "ZPS4",
	"./feelgrid.leaf.icon.svg": "22xX",
	"./feelgrid.pollution.icon.svg": "pSz0",
	"./feelgrid.pressure.icon.svg": "vqr+",
	"./feelgrid.soil.icon.svg": "CREj",
	"./feelgrid.temperature.icon.svg": "TiAg",
	"./fill-in.icon.svg": "QU6a",
	"./fullscreen.icon.svg": "2Qpv",
	"./fullscreen_exit.icon.svg": "W+8A",
	"./gamify.logo.icon.svg": "UDnv",
	"./gamify.status.icon.svg": "Jf82",
	"./hand-wrench.icon.svg": "LRas",
	"./hand.icon.svg": "JW0i",
	"./home.icon.svg": "Muzj",
	"./hourglass.icon.svg": "O5M+",
	"./human.icon.svg": "SlQ1",
	"./image.icon.svg": "4rHz",
	"./imports.icon.svg": "qAPs",
	"./info-round.icon.svg": "ebMS",
	"./interact.icon.svg": "mtG2",
	"./interact2.icon.svg": "vNdh",
	"./invisible.icon.svg": "Ckzy",
	"./key.icon.svg": "mDrW",
	"./like.icon.svg": "dYG+",
	"./list.icon.svg": "wKiL",
	"./loyaltyvenue.icon.svg": "1tL8",
	"./loyaltyvenue.points.icon.svg": "iQCu",
	"./magic-wand.icon.svg": "f5rX",
	"./medal.icon.svg": "NT4U",
	"./megaphone-full.icon.svg": "2OEH",
	"./megaphone.icon.svg": "ssXG",
	"./no.icon.svg": "LALb",
	"./orderlist.icon.svg": "zMt2",
	"./out.icon.svg": "0P13",
	"./pencil.icon.svg": "vmmc",
	"./phone.icon.svg": "/9Pe",
	"./piechart.icon.svg": "QdvL",
	"./pinterest.icon.svg": "gC2x",
	"./placeholder.icon.svg": "ZnVw",
	"./refresh.icon.svg": "bY0T",
	"./search.icon.svg": "P6f/",
	"./stack.icon.svg": "UPDu",
	"./store.icon.svg": "g26y",
	"./tick.icon.svg": "fMbk",
	"./trash.icon.svg": "Jut4",
	"./triangle.icon.svg": "JWkH",
	"./trophy.icon.svg": "JXED",
	"./twitter.icon.svg": "/R7B",
	"./user-outline.icon.svg": "CDte",
	"./user.icon.svg": "oHyk",
	"./users.icon.svg": "1WKg",
	"./view-compact.icon.svg": "+qyx",
	"./view-list.icon.svg": "wcHy",
	"./view-tiles.icon.svg": "VHJp",
	"./visible.icon.svg": "dU70"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7Azc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^.*\.icon.svg$/
// module id = 7Azc
// module chunks = 13